/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const RemoveMyEmailBody = zod.object({
  email: zod.email().describe('The secondary address to remove'),
});

export type RemoveMyEmailBody = zod.input<typeof RemoveMyEmailBody>;
export type RemoveMyEmailBodyOutput = zod.output<typeof RemoveMyEmailBody>;
